import { RefObject, useEffect } from 'react';

const useFocusOnRender = (ref: RefObject<HTMLElement>) => {
    useEffect(() => {
        if (ref.current) {
            ref.current.focus();
        }
    }, [ref]);
};

export default useFocusOnRender;
